import { DataSourceMode, } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutDriverImage } from "./autogen/AutogenLayoutDriverImage";

export class DriverImage extends AutogenLayoutDriverImage {

    override onLoad(): void | Promise<void> {

        this.attachmentDriverImage.setAttachmentWithUI = (file: File) => {
            const maxSize = this.attachmentDriverImage.maxSize;
            const fileName = file.name.toLowerCase();
            if (!fileName.endsWith(".jpg") && !fileName.endsWith(".jpeg") && !fileName.endsWith(".png") && !fileName.endsWith(".gif"))
                return this.showAdhocTooltip("The file must be an image.", { shaking: true, timeout: 5000 });
            else if (maxSize != null && file.size > maxSize)
                return this.showAdhocTooltip("The file is too big to attach. The file must be smaller than " + this.attachmentDriverImage.maxSize / (1024 * 1024) + "MB.", { shaking: true, timeout: 5000 });
            else {
                this.attachmentDriverImage.setFile(file);
            }
        }

        this.attachmentDriverImage.updateIfBound = () => {
            if (this.attachmentDriverImage["_boundField"] != null) {
                const imageData = new Map<String, any>([
                    ["driver_id", this.mainDataSource.owner.mainDataSource.data[0].data.id],
                    ["driver_image", this.attachmentDriverImage.fileBase64],
                    ["driver_image_name", this.attachmentDriverImage.fileName]
                ]);
                if (this.sourceDriverImage.data.length == 0)
                    this.setupNewImage(imageData)
                let row = null;
                if (this.attachmentDriverImage.dataSource != null && this.attachmentDriverImage.dataSource.activeRow != null)
                    row = this.attachmentDriverImage.dataSource.activeRow;
                else if (this.attachmentDriverImage.boundRow != null)
                    row = this.attachmentDriverImage.boundRow;
                if (row != null)
                    this.attachmentDriverImage.updateBoundData(row, DataSourceMode.UPDATE);
            }
        }
    }

    private async setupNewImage(imageData: Map<String, any>) {
        const row = await this.sourceDriverImage.createBlankRow();
        for (const key of imageData.keys()) {
            row.set(key, imageData.get(key));
        }
        this.sourceDriverImage.addRow(new ModelRow('lme/dispatch/asset/driver-image', true, row.data), 0, false);
        this.sourceDriverImage.setRowIndexWithoutUpdate(0)
        const active = this.sourceDriverImage.activeRow
        active.set("driver_id", active.data.driver_id) //Setting this value to itself updates the save button
    }

}
